// extracted by mini-css-extract-plugin
export default {"secondaryBtn":"secondarybutton_secondaryBtn__BebvW"};